<template>
  <div class="mobile-view">
    <header class="header">
      <a class="back" @click.prevent="goBack" role="button" tabindex="0">
        <span class="iconfont-arrow-left"></span>
      </a>
      <div class="heading-primary">{{ $t('my_account.addresses.select_address') }}</div>
    </header>
    <div class="content">
      <SavedAddresses />
    </div>
    <footer class="footer">
      <button
          type="submit"
          name="submit"
          class="b b-A checkout-v2-btn"
          @click.prevent="addNewAddress"
      >
        {{ $t('my_account.addresses.add_address') }}
      </button>
    </footer>
  </div>
</template>
<style lang="scss" src="./styles.scss" scoped></style>

<script setup>
import { useRoute, useRouter } from "vue-router"
import SavedAddresses from "@/app/Checkout/components/mobile/SavedAddresses/index.vue"

const route = useRoute()
const router = useRouter()

const addNewAddress = () => {
  router.push({ name: 'AddAddress', query: { type: route?.query?.type } })
}

const goBack = () => {
  window.history.back()
}

</script>
